(() => {
  const root = document.querySelector('[data-signature-product]');
  if (!root) return;
  const normalizeSize = value => {
    const key = value.trim().toUpperCase();
    return ({'2XL':'XXL','XXXL':'3XL','XXXXL':'4XL','XXXXXL':'5XL'})[key] || key;
  };
  const arrangeColours = () => root.querySelectorAll('.signature-colour-options').forEach(group => {
    const count = group.children.length;
    const capacity = Math.max(1, Math.floor((group.clientWidth + 8) / 78));
    const rows = Math.max(1, Math.ceil(count / capacity));
    const columns = Math.max(1, Math.ceil(count / rows));
    group.style.gridTemplateColumns = `repeat(${columns}, minmax(0, 70px))`;
  });
  const fitTitle = () => {
    const title = root.querySelector('h1');
    if (!title) return;
    title.style.fontSize = '';
    let size = parseFloat(getComputedStyle(title).fontSize);
    while (title.scrollWidth > title.clientWidth + 1 && size > 13) {
      size -= .5;
      title.style.fontSize = `${size}px`;
    }
  };
  root.querySelectorAll('[data-size]').forEach(button => button.dataset.size = normalizeSize(button.dataset.size));
  const resize = () => { arrangeColours(); fitTitle(); };
  resize();
  if ('ResizeObserver' in window) new ResizeObserver(resize).observe(root);
  else window.addEventListener('resize',resize);
  document.fonts?.ready.then(resize);
})();
